export { DarkProvider } from './Provider'
export type { DarkProviderIProps } from './Provider'
export { SELECTION_BG_VAR, SELECTION_FG_VAR } from './Provider.styles'
